import { render, staticRenderFns } from "./user-Profile.vue?vue&type=template&id=a3c24c38&scoped=true&"
import script from "./user-Profile.vue?vue&type=script&lang=js&"
export * from "./user-Profile.vue?vue&type=script&lang=js&"
import style0 from "./user-Profile.vue?vue&type=style&index=0&id=a3c24c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c24c38",
  null
  
)

export default component.exports